module.exports = __webpack_public_path__ + "media/images/mobile/solutions/13-738295536fb74ca89270b6395f574802.png";